import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Table, TBody, TrHead, Td, Tr, Th } from 'merchant-portal-components';

const NoOfferCredits = styled.div`
  text-align: center;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  height: 250px;
  font-size: 38px;
  color: #d8d8d8;
`;

const renderHeaders = () => (
  <TrHead data-test='component-TrHead'>
    <Th align='left'>Offer name</Th>
    <Th align='left'>Amount</Th>
  </TrHead>
);

const renderRows = (offerCredits) =>
    offerCredits.map((offerCredit, index) => (
    <Tr
      key={index}
      data-test='component-Tr'
    >
      <Td align='left'>{offerCredit.offer_name}</Td>
      <Td align='left'> {Number(offerCredit.amount) 
          ? Number(offerCredit.amount).toFixed(2) 
          : '0.00'}</Td>
    </Tr>
  ));

export const CustomerOfferCreditBalanceTable = (props) => {
  const { offerCreditBalance} = props;
  return (
    
    <Fragment>
      <Table data-test='component-Table'>
        <thead>{renderHeaders()}</thead>
        {offerCreditBalance.length ? (
          <TBody striped>
            {renderRows(offerCreditBalance, history)}
          </TBody>
        ) : null}
      </Table>
      {!offerCreditBalance.length ? (
        <NoOfferCredits data-test='component-NoOfferCredits'>
          No Record Found
        </NoOfferCredits>
      ) : null}
    </Fragment>
  );
};

export default CustomerOfferCreditBalanceTable;
